import React from 'react';
import Image from 'next/image';
import { Styles } from './styles';
import HTMLParsedContent from '../HTMLParsedContent';
import SocialMedias from '../SocialMedias';

export type InstructorCardProps = {
  name: string;
  role?: string;
  body?: string;
  image?: {
    url: string;
  };
  facebookUrl?: string;
  twitterUrl?: string;
  linkedinUrl?: string;
  youtubeUrl?: string;
  instagramUrl?: string;
};

const InstructorCard: React.FC<InstructorCardProps> = ({ name, role, body, image, ...props }) => {
  return (
    <Styles>
      <div className="instructor-img">
        <Image quality={50} fill style={{ objectFit: 'cover' }} src={image?.url || ''} alt={name} />
      </div>
      <div className="instructor-box">
        <div className="top-content d-flex justify-content-between">
          <div className="instructor-name">
            <h6>{name}</h6>
            {role && <p>{role}</p>}
          </div>
          <SocialMedias {...props} />
        </div>
        <HTMLParsedContent className="instructor-desk" content={body} />
      </div>
    </Styles>
  );
};

export default InstructorCard;
